"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyWorkWithUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="235594" id="diferencial" className="bg-background text-foreground py-40 px-6 md:px-12 overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h2 className="text-foreground font-default text-3xl md:text-5xl font-bold mb-8 tracking-tighter">
          Produção + estratégia no mesmo lugar
        </h2>

        <p className="text-muted-foreground font-default text-lg md:text-xl leading-relaxed mb-12 max-w-2xl">
          Você não precisa contratar várias empresas. Na ITC+, você encontra estrutura, equipe e direcionamento para transformar conteúdo em resultado.
        </p>

        <Button asChild variant="ghost" size="lg" className="border-2 border-primary rounded-full px-10 py-7 text-lg font-default text-foreground hover:bg-primary/10 transition-all duration-300 shadow-sm">
          <Link to="https://itcmais.com/o-estudio/" newTab>Conheça o Estúdio</Link>
        </Button>
      </div>
    </section>;
}